module.exports = __webpack_public_path__ + "media/images/avatar/avatar-photo-placeholde-78369c7e27943e6e4e22ca845f71248f.png";